import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=7c630fda&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"
import style0 from "./comments.vue?vue&type=style&index=0&id=7c630fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c630fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c630fda')) {
      api.createRecord('7c630fda', component.options)
    } else {
      api.reload('7c630fda', component.options)
    }
    module.hot.accept("./comments.vue?vue&type=template&id=7c630fda&scoped=true&", function () {
      api.rerender('7c630fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/tabs/comments.vue"
export default component.exports